import { useDispatch, useSelector } from 'react-redux';
import React from 'react'
import { useTranslation } from 'react-i18next';

import { useProfileContext } from '../../../Contexts/ProfileContext';
import { toggleDialog } from '../../../../redux/Slices/Global/globalSlice';

import PaymentForm from './PaymentForm';
import FeaturesList from './FeaturesList';
import { Dialog } from 'primereact/dialog';

function PaymentDialog() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { openDialog, showPaymentsPlans, companyDetails } = useSelector((state) => state.global);
  const { paymentData, selectedPackage, numberOfScreens, action, isUpgrade } = useProfileContext();

  const closeDialog = () => {
    dispatch(toggleDialog("paymentDialog"));
  }
  function dstr(s) {
    if (!s) return "--";
    const d = new Date(s);
    return d.toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
  }

  return (
    <Dialog visible={openDialog.paymentDialog}
      breakpoints={{
        '960px': '95vw',
        '600px': '95vw',
      }}
      style={{ width: action == "addScreens" ? 'min(95vw, 460px)' : 'min(95vw, 820px)' }}
      modal
      className="p-fluid custom-dialog position-relative"
      onHide={() => closeDialog()}
    >
      {/* Close button  */}
      <button className='position-absolute close_icon text-primary' onClick={() => closeDialog()} >
        <i className="fa-regular fa-circle-xmark text-primary"></i>
      </button>

      <div className=" flex  flex-col flex-lg-row ">
        <div className={`${action == "addScreens" ? "" : "col-lg-7"} col-12   flex flex-column p-5`}  >
          <span className='fs-5 fw-bold mb-2'>{t('payment.payment_details')}</span>

          <div className='d-flex flex-wrap mb-3'>
            <div className="col-12 col-sm-6">
              <div className="fw-light fs-6"><span className='fw-bold fs-6'>{t('payment.label_plan')} </span>  {selectedPackage?.title}</div>
              <div className="fw-light fs-6"><span className='fw-bold fs-6'>{t('payment.label_period')} </span>  {(paymentData?.period?.replace(/_/g, ' '))?.toLowerCase()}</div>
              <div className="fw-light fs-6"><span className='fw-bold fs-6'>{t('payment.label_number_of_screens')} </span> {numberOfScreens}</div>
            </div>
            <div className="col-12 col-sm-6">
              <div className="fw-light fs-6"><span className='fw-bold fs-6'>{t('payment.label_subtotal')} </span>  $ {paymentData?.subtotal} </div>
              <div className="fw-light fs-6"><span className='fw-bold fs-6'>{t('payment.label_fee')} </span>$ {paymentData?.tax}</div>
              <div className="fw-light fs-6"><span className='fw-bold fs-6'>{t('payment.label_total')} </span>$ {paymentData?.total}</div>
            </div>

            {showPaymentsPlans &&
              isUpgrade ?
              companyDetails?.subscription?.status === "ACTIVE" ?

                <>
                  <div className="fw-light fs-6">
                    <span className='fw-bold fs-6'>

                    </span>
                  </div>
                </>
                : ""
              :
              action != "addScreens" &&
              <>
                <div className="fw-light mt-3 fs-6">
                  {t('payment.subscription_update_notice')}
                </div>
              </>

            }

          </div>

          <PaymentForm closeDialog={closeDialog} />
        </div>

        {
          action != "addScreens" && (
            <div className="col-12  col-lg-5  flex flex-column p-5 bg_gray">
              <span className='fs-5 fw-bold mb-2'>{t('payment.what_will_you_get')}</span>
              <FeaturesList selectedPackage={selectedPackage} />
            </div>
          )
        }

      </div >
    </Dialog>
  )
}

export default PaymentDialog